import { render, staticRenderFns } from "./DoctorManage.vue?vue&type=template&id=65aad832"
import script from "./DoctorManage.vue?vue&type=script&lang=js"
export * from "./DoctorManage.vue?vue&type=script&lang=js"
import style0 from "./DoctorManage.vue?vue&type=style&index=0&id=65aad832&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports